import { useSetAtom as t, useAtomValue as r } from "jotai/index";
import { setBookingSummaryShowAtom as S, bookingSummaryShowAtom as u } from "./index25.mjs";
const s = () => {
  const o = t(S), m = r(u);
  return {
    setBookingSummaryShow: o,
    isShowBookingSummary: m
  };
};
export {
  s as useBookingSummaryShow
};
